<template>
    <div>
        <div class="hidden-sm-and-down" style="display: inline-block;">
            <!-- <v-btn class="mr-3 px-1 button-text secondary--text text--lighten-1 subtitle-2 font-weight-medium" text>
                <v-icon>help_outline</v-icon>
                <span class="ml-1 subtitle-2">Ajuda</span>
            </v-btn>
 -->
            <v-menu right offset-y width="100" style="border: 1px solid red;">
                <template v-slot:activator="{ on }">
                    <v-btn class="mr-3 px-1 button-text secondary--text text--lighten-1 subtitle-2 font-weight-medium" text
                        v-on="on">
                        <v-icon>notifications_none</v-icon>

                        <!-- <v-badge v-if="stormAlerts.length" color="secondary lighten-1" :content="stormAlerts.length" inline> -->
                            <span>Alertas</span>
                        <!-- </v-badge>
                        <span v-else>Alertas</span> -->
                    </v-btn>

                </template>
                <!-- <alerts-menu :stormAlerts="stormAlerts"></alerts-menu>-->
            </v-menu>

            <v-btn class="mr-3 px-1 button-text secondary--text text--lighten-1 subtitle-2 font-weight-medium" text
                to="/Reports">
                <v-icon>mdi-folder-outline</v-icon>
                <span class="ml-1 subtitle-2">Repositório de relatórios</span>
                <v-badge v-if="notification.length" :content="notification.length" color="secondary lighten-1"
                    inline></v-badge>
            </v-btn>
        </div>

        <v-menu right offset-x offset-y min-width="140">
            <template v-slot:activator="{ on }">
                <v-btn class="px-1 button-text secondary--text text--lighten-1 subtitle-2 font-weight-medium" height="40"
                    v-on="on" outlined>
                    <v-avatar size="37">
                        <!--  <img v-if="user.avatar && user.avatar.url" :src="user.avatar.url" alt="Foto-Avatar" /> -->
                        <v-icon size="28">fas fa-user-circle</v-icon>
                    </v-avatar>
                    <span v-if="currentUser" class="secondary--text text--lighten-2"
                        :style="$vuetify.breakpoint.name === 'xs' ? 'max-width: 80px; overflow: hidden;text-overflow: ellipsis;' : ''">
                        Olá,&nbsp;{{ currentUser ? currentUser.attributes.name : "" }}
                    </span>
                    <v-icon class="ml-sm-2">arrow_drop_down</v-icon>
                </v-btn>

            </template>

            <!--  <profile-menu></profile-menu> -->

            <v-list dense class="py-4" min-width="250">
                <div class="hidden-md-and-up">
                    <v-list-item class="px-4" link>
                        <v-list-item-icon class="mr-1">
                            <v-icon class="secondary--text text--lighten-1">notifications_none</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="secondary--text text--lighten-1">
                            <!--<v-badge v-if="stormAlerts.length" color="secondary lighten-1" :content="stormAlerts.length"
                                inline>-->
                                <span>Alertas</span>
                            <!--</v-badge>
                            <span v-else>Alertas</span>-->

                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="px-4" link>
                        <v-btn class="mr-3 px-1 button-text secondary--text text--lighten-1 subtitle-2 font-weight-medium"
                            text to="/Reports">
                            <v-icon>mdi-folder-outline</v-icon>
                            <span class="ml-1 subtitle-2">Repositório de relatórios</span>
                            <v-badge v-if="notification.length" :content="notification.length" color="secondary lighten-1"
                                inline></v-badge>
                        </v-btn>
                    </v-list-item>
                </div>
                <!-- <v-list-item link>
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-pencil-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Editar</span>
                    </v-list-item-content>
                </v-list-item> -->
                <v-list-item link @click="goToGuides">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-help-circle-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Manual do Usuário</span>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="logOut">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-exit-to-app</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Sair</span>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

        </v-menu>
    </div>
</template>

<script>
import routes from "@/router/routes";
// import AlertsMenu from "./AlertsMenu.vue";
import moment from "moment";

export default {
    name: "ItemsMenu",
    /*components: {
        AlertsMenu
    },*/
    data() {
        return { notification: [] }
    },
    async created() {
        let nowDate = moment().format('YYYY-MM-DDTHH:mm:ss+0000');
        // await this.$store.dispatch('loadStormAlerts', { limit: 3 });
        await this.$store.dispatch("loadReports");
        let reports = await this.$store.getters.reports;
        reports = reports.map(function (item) {
            return { diff: moment(nowDate, 'YYYY-MM-DDTHH:mm:ss+0000').diff(moment(item.createdAt, 'YYYY-MM-DDTHH:mm:ss+0000'), 'hours') };
        })
        let news = reports.filter(function (item) { return item.diff <= 24 });
        this.notification = news;
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        /*stormAlerts() {
            let storms = this.$store.getters.storms.filter((alert) => alert.servico.codigo === 3);

            storms = storms.map((alert) => ({
                ...alert,
                status: alert.tempestade === 0 ? "Saindo de Alerta" : "Em Alerta",
                observacao: alert.observacao ? alert.observacao : "Observação não informada."
            }));
            return storms;
        },*/
    },
    methods: {
        logOut() {
            this.$store.dispatch('logOut');
            this.$router.push(routes.login.path);
        },
        goToGuides() {
            this.$router.push('/Guides').catch(() => {})
        }
    }
}
</script>

<style></style>
